import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

import * as deleteDialog from './delete-dialog'
import * as editDialog from './edit-dialog'
import * as overlay from './overlay'

@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [
    deleteDialog.Component,
    editDialog.Component,
    overlay.Component,
    ds.button.Component,
    ds.overlay.attached.Component,
  ],
  selector: 'atn-scenario-dropdown',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /** Opens the scenario dropdown overlay. */
  public appHeaderScenarioClickedHandler() {
    this.scenariosFeature.actions.displayOverlay
      .from('AppHeader.Scenario.Clicked')
      .dispatch()
  }

  /** Closes the scenario dropdown overlay after backdrop click. */
  public scenarioOverlayBackdropClickedHandler() {
    this.scenariosFeature.actions.closeOverlay
      .from('ScenarioOverlay.Backdrop.Clicked')
      .dispatch()
  }

  /** Opens a create dialog when the app has no scenarios yet. */
  public addBtnClickedHandler() {
    if (
      !this.meFeature.contexts.selectors.currentUserCanCreateScenario.asSignal()
    ) {
      return
    }

    this.scenariosFeature.actions.openCreate
      .from('Header.Scenario.Buttons.Add.Clicked')
      .dispatch()
  }
}
